<template>
  <div style="direction: ltr; text-align: left;">
  <div v-if="!user" class="loginWrapper d-flex align-items-center justify-content-center">
    <div class="loginCard p-4">
      <h4 class="mb-4 text-center">Admin Login</h4>
      <div class="form-group mb-3">
        <input type="email" class="form-control" placeholder="Email" v-model="loginEmail" @keyup.enter="login" />
      </div>
      <div class="form-group mb-3">
        <input type="password" class="form-control" placeholder="Password" v-model="loginPassword" @keyup.enter="login" />
      </div>
      <div v-if="loginError" class="alert alert-danger py-2 mb-3" style="font-size: 14px;">{{ loginError }}</div>
      <button class="btn btn-primary w-100" @click="login">Login</button>
      <div class="d-flex align-items-center my-3">
        <hr class="flex-grow-1" /><span class="mx-2 text-muted" style="font-size: 13px;">or</span><hr class="flex-grow-1" />
      </div>
      <button class="btn btn-outline-dark w-100 d-flex align-items-center justify-content-center gap-2" @click="loginWithGoogle">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 48 48">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.96 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        Sign in with Google
      </button>
    </div>
  </div>
  <div v-else class="adminWrapper">
    <div class="d-flex justify-content-end align-items-center py-2 px-2 border-bottom mb-2">
      <small class="text-muted me-3">{{ user.email }}</small>
      <button class="btn btn-outline-secondary btn-sm" @click="logout">Logout</button>
    </div>

    <div v-if="actionError" class="alert alert-danger py-2 mx-2 mb-2 d-flex justify-content-between align-items-center">
      <span>{{ actionError }}</span>
      <button type="button" class="btn-close" aria-label="Close" @click="actionError = ''"></button>
    </div>
    <div v-if="actionSuccess" class="alert alert-success py-2 mx-2 mb-2 d-flex justify-content-between align-items-center">
      <span>{{ actionSuccess }}</span>
      <button type="button" class="btn-close" aria-label="Close" @click="actionSuccess = ''"></button>
    </div>

    <!-- ******************************POINTS*************************** -->

    <!-- ******************************POP UP CREATE NEW ITEMS*************************** -->

    <div v-if="showNewItemWindow">
      <div class="p-3 newQuestion">
        <div v-if="loading">
          <div class="spinner-border text-primary center" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <form @submit.prevent="createNewItem" width="90%" v-else>
          <div class="closeDiv"
            @click="showNewItemWindow = false; itemName = ''; vitrine = ''; material = ''; place = ''; period = ''; pointNumber = '';">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
          <div class="form-group">
            <label for="pointNumber">Point number</label>
            <input name="pointNumber" id="pointNumber" type="number" v-model="pointNumber" required class="form-control"
              aria-describedby="pointNumber" placeholder="Point number" />
          </div>

          <!-- <div class="mb-2 form-group"> -->
          <div class v-if="showUploadImage">
            <button tag="label" type="button" class="btn btn-primary mt-5 mb-5 btn-lg btn-block btn-sm"
              @click="onPickFile">
              Upload Image
              <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked" />
            </button>
          </div>
          <div>
            <img :src="imageUrl" ref="imageToCanvas" style="display: none" />
            <canvas ref="canvas" v-if="showCanvas" class="fitScreen"></canvas>
            <button block v-if="showCanvas" @click="onPickFile2" class="btn btn-primary mt-3 btnEditChangeImage mb-3">
              Change image
            </button>
            <input type="file" style="display: none" ref="fileInput2" accept="image/*" @change="onFilePicked" />
          </div>
          <div class="form-group">
            <label for="vitrine">Vitrine</label>
            <input class="form-control" aria-describedby="vitrine" placeholder="vitrine" name="vitrine" dark
              label="vitrine" id="vitrine" v-model="vitrine" required />
          </div>
          <div class="form-group">
            <label for="itemName">שם</label>
            <input class="form-control" aria-describedby="itemName" placeholder="itemName" name="itemName" dark
              label="itemName" id="itemName" v-model="itemName" required />
          </div>
          <div class="form-group">
            <label for="pointInformation">תיאור</label>
            <textarea class="form-control" aria-describedby="pointInformation" placeholder="Point information"
              name="pointInformation" dark label="pointInformation" id="pointInformation" v-model="pointInformation"
              rows="3"></textarea>
          </div>
          <div class="form-group">
            <label for="material">חומר</label>
            <input class="form-control" aria-describedby="material" placeholder="material" name="material" dark
              label="material" id="material" v-model="material" />
          </div>
          <div class="form-group">
            <label for="place">אתר</label>
            <input class="form-control" aria-describedby="place" placeholder="place" name="place" dark label="place"
              id="place" v-model="place" />
          </div>
          <div class="form-group">
            <label for="period">תקופה</label>
            <input class="form-control" aria-describedby="period" placeholder="period" name="period" dark label="period"
              id="period" v-model="period" />
          </div>
          <div xs12>
            <button block type="submit" outline class="btn btn-primary mt-5 btn-lg btn-block btn-sm">
              <div v-if="loading" class="spinner-border text-primary center" role="status">
                <span class="sr-only"></span>
              </div>
              <!-- <span slot="loader" v-if="loading" class="custom-loader"></span> -->
              <span v-else>Create new item</span>
            </button>
          </div>
        </form>
      </div>
    </div>

        <!-- ******************************END OF POP UP CREATE NEW ITEMS*************************** -->


    <!-- ******************************POP UP CREATE NEW VITRINE*************************** -->

    <div v-if="showNewVitrineWindow">
      <div class="p-3 newQuestion">
        <div v-if="loading">
          <div class="spinner-border text-primary center" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <form @submit.prevent="createNewVitrine" width="90%" v-else>
          <div class="closeDiv"
            @click="showNewVitrineWindow = false; itemName = ''; vitrine = ''; material = ''; place = ''; period = ''; pointNumber = '';">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
          <div class="form-group">
            <label for="pointNumber">Vitrine number</label>
            <input name="pointNumber" id="pointNumber" type="number" v-model="pointNumber" required class="form-control"
              aria-describedby="pointNumber" placeholder="Vitrine number" />
          </div>

          <!-- <div class="mb-2 form-group"> -->
          <div class v-if="showUploadImage">
            <button tag="label" type="button" class="btn btn-primary mt-5 mb-5 btn-lg btn-block btn-sm"
              @click="onPickFile">
              Upload Image
              <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked" />
            </button>
          </div>
          <div>
            <img :src="imageUrl" ref="imageToCanvas" style="display: none" />
            <canvas ref="canvas" v-if="showCanvas" class="fitScreen"></canvas>
            <button block v-if="showCanvas" @click="onPickFile2" class="btn btn-primary mt-3 btnEditChangeImage mb-3">
              Change image
            </button>
            <input type="file" style="display: none" ref="fileInput2" accept="image/*" @change="onFilePicked" />
          </div>
          <div class="form-group">
            <label for="vitrine">Vitrine</label>
            <input class="form-control" aria-describedby="vitrine" placeholder="vitrine" name="vitrine" dark
              label="vitrine" id="vitrine" v-model="vitrine" required />
          </div>
          <div class="form-group">
            <label for="itemName">שם</label>
            <input class="form-control" aria-describedby="itemName" placeholder="itemName" name="itemName" dark
              label="itemName" id="itemName" v-model="itemName" required />
          </div>
          <div class="form-group">
            <label for="pointInformation">תיאור</label>
            <textarea class="form-control" aria-describedby="pointInformation" placeholder="Point information"
              name="pointInformation" dark label="pointInformation" id="pointInformation" v-model="pointInformation"
              rows="3"></textarea>
          </div>
          <div xs12>
            <button block type="submit" outline class="btn btn-primary mt-5 btn-lg btn-block btn-sm">
              <div v-if="loading" class="spinner-border text-primary center" role="status">
                <span class="sr-only"></span>
              </div>
              <!-- <span slot="loader" v-if="loading" class="custom-loader"></span> -->
              <span v-else>Create new vitrine</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- ******************************END OF POP UP CREATE NEW VITRINE*************************** -->

          <!-- ********************************VITRINE ORDER OPTIONS****************************************************************************** -->

          <div v-if="showVitrineOrder">
          <div class="form-group mb-3 tabpanel p-3 newQuestion">
            <div class="closeDiv"
            @click="showVitrineOrder = false">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </div>
            <div class="text-center border-bottom pb-2 mb-2">Vitrine order</div>
            <div class="border-bottom pb-2 mb-2" style="font-size: 12px">
              The vitrine order is the order in which the user will go from vitrine
              to the other.
            </div>
            <div class="row mb-3">
              <div class="col-7">Add a vitrine number to the list:</div>
              <input ref="inputInFocus" class="form-control col-2 ms-3 py-0" aria-describedby="newPointToArray"
                placeholder name="newPointToArray" dark label="newPointToArray" id="newPointToArray"
                v-model="newPointToArray" style="height: 30px" />

              <div class="col-1 ps-0 ms-1" style="
                font-size: 22px;
                color: #007bff;
                padding: 0px;
                margin-top: -4px;
              ">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor"
                  class="bi bi-plus-circle-fill" viewBox="0 0 16 16" @click="addPointToArray">
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                </svg>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="mb-1">Vitrine order list:</div>
                <div v-for="(num, idx) in pointsOrder" :key="idx" class="d-flex align-items-center mb-1">
                  <span class="me-2" style="min-width: 30px;">{{ num }}</span>
                  <button type="button" class="btn btn-sm btn-outline-secondary me-1" :disabled="idx === 0"
                    @click="moveOrderItem(idx, -1)">↑</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary me-1"
                    :disabled="idx === pointsOrder.length - 1" @click="moveOrderItem(idx, 1)">↓</button>
                  <button type="button" class="btn btn-sm btn-outline-danger" @click="pointsOrder.splice(idx, 1)">×</button>
                </div>
              </div>
              <div class="col-3 mt-2">
                <button type="button" class="btn btn-danger" @click="eraseVitrineOrder">
                  Erase
                </button>
              </div>
              <div class="col-2 mt-2">
                <button type="button" class="col-1 ps-0 me-4 float-end" @click="storeVitrineOrder" style="
                  font-size: 31px;
                  color: #007bff;
                  padding: 0px;
                  margin-top: -7px;
                  border: none;
                ">
                  <svg class="bi bi-arrow-right-circle-fill" width="1em" height="1em" viewBox="0 0 16 16"
                    fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8.354 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L9.793 7.5H5a.5.5 0 0 0 0 1h4.793l-2.147 2.146z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>        
        
          <!-- ********************************END OF VITRINE ORDER OPTIONS******************************************************************************* -->

    <!-- ******************************END OF POP UP NEW ITEMS*************************** -->


    <div class="tab-content px-sm-0" id="nav-tabContent">
      <div class="tab-pane fade show active" id="nav-points" role="tabpanel" aria-labelledby="nav-points-tab">
        <!-- ******************************VITRINE LIST WITH LANGUAGE*************************** -->
        <div class="tab-pane fade show active" id="nav-points" role="tabpanel" aria-labelledby="nav-points-tab">
          <div class="row mx-0 pt-2">
            <div class="col-4 text-center langTab" :class="{ active: lang === 'en' }"
              @click="(lang = 'en'), switchLangToEnglish()">
              English
            </div>
            <div class="col-4 text-center langTab" :class="{ active: lang === 'he' }"
              @click="(lang = 'he'), switchLangToHebrew()">
              Hebrew
            </div>
            <div class="col-4 text-center langTab" :class="{ active: lang === 'ar' }"
              @click="(lang = 'ar'), switchLangToArabic()">
              Arabic
            </div>
          </div>


          <Teleport to="body">
          <div class="btn fabButton pmd-ripple-effect btn-primary" type="button" title="Add"
            aria-label="Add" @click="showNewItemsOption = !showNewItemsOption">
            <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
              xmlns="http://www.w3.org/2000/svg" style="font-size: 54px">
              <path fill-rule="evenodd"
                d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
            </svg>
          </div>
          <div v-if="showNewItemsOption">
            <div class="btn fabButton pmd-ripple-effect newItemsButtons" type="button" title="New item"
              aria-label="New item" @click="showNewItemWindow = true; showNewItemsOption = false; scrollToTop()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-tools"
                viewBox="0 0 16 16">
                <path
                  d="M1 0 0 1l2.2 3.081a1 1 0 0 0 .815.419h.07a1 1 0 0 1 .708.293l2.675 2.675-2.617 2.654A3.003 3.003 0 0 0 0 13a3 3 0 1 0 5.878-.851l2.654-2.617.968.968-.305.914a1 1 0 0 0 .242 1.023l3.27 3.27a.997.997 0 0 0 1.414 0l1.586-1.586a.997.997 0 0 0 0-1.414l-3.27-3.27a1 1 0 0 0-1.023-.242L10.5 9.5l-.96-.96 2.68-2.643A3.005 3.005 0 0 0 16 3c0-.269-.035-.53-.102-.777l-2.14 2.141L12 4l-.364-1.757L13.777.102a3 3 0 0 0-3.675 3.68L7.462 6.46 4.793 3.793a1 1 0 0 1-.293-.707v-.071a1 1 0 0 0-.419-.814L1 0Zm9.646 10.646a.5.5 0 0 1 .708 0l2.914 2.915a.5.5 0 0 1-.707.707l-2.915-2.914a.5.5 0 0 1 0-.708ZM3 11l.471.242.529.026.287.445.445.287.026.529L5 13l-.242.471-.026.529-.445.287-.287.445-.529.026L3 15l-.471-.242L2 14.732l-.287-.445L1.268 14l-.026-.529L1 13l.242-.471.026-.529.445-.287.287-.445.529-.026L3 11Z" />
              </svg>
            </div>
            <div class="btn fabButton pmd-ripple-effect newItemsButtons" type="button" title="New vitrine"
              aria-label="New vitrine" @click="showNewVitrineWindow = true; showNewItemsOption = false; scrollToTop()"
              style="bottom: 130px !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-aspect-ratio" viewBox="0 0 16 16">
                <path
                  d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
                <path
                  d="M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z" />
              </svg>
            </div>
            <div class="btn fabButton pmd-ripple-effect newItemsButtons" type="button" title="Vitrine order"
              aria-label="Vitrine order" @click="openVitrineOrder()"
              style="bottom: 186px !important;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear"
                viewBox="0 0 16 16">
                <path
                  d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
                <path
                  d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
              </svg>
            </div>
          </div>
          </Teleport>

          <div v-if="loading">
            <div class="spinner-border text-primary center" role="status">
              <span class="sr-only"></span>
            </div>
          </div>


          <!-- ******************PRESENTATION FOR VITRINE ONLY*************************** -->



          <div v-else v-for="(vitrineItem, indexVitrines) in vitrinesMain" :key="indexVitrines"
            :class="{ active: index === activePoint }"
            class="d-flex justify-content-center px-2">
            <div class="mb-2 border-bottom bg-white pb-2" style="max-width: 590px; width: 100%">
              <!-- ******************NORMAL VITRINES PRESENTATION*************************** -->

              <div class="row px-3 pt-3 pb-2 vitrineCard" style="
                  width: 100%;
                  display: block;
                  margin: 0 auto;
                  max-width: 590px;
                " v-if="vitrineItem.editMode != true">

                <div class="row mb-2">
                  <div class="col-8 mb-2 h4">Vitrine Number:</div>
                  <div class="col-4 h4">
                    {{ vitrinesMain[indexVitrines].results.pointNumber }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <img :src="vitrinesMain[indexVitrines].results.imageBase64" alt="" style="width: 100%" />
                  </div>
                </div>
                <div class="row border-bottom my-3">
                  <div class="col-6">Vitrine name:</div>
                  <div class="col-6 mb-2" style="background: #e6e66254; text-align: center">
                    {{ vitrinesMain[indexVitrines].results.itemName }}
                  </div>
                </div>

                <div class="row border-bottom my-2">
                  <div class="col-12">Vitrine information:</div>
                  <div class="col-11 mb-2" style="
                      background: #e6e66254;
                      text-align: right;
                      display: block;
                      margin: 0 auto;
                    ">
                    {{ vitrinesMain[indexVitrines].results.pointInformation }}
                  </div>
                </div>
                <div class="row" style="width: 100%;">
                  <button type="button" class="col-4 btn btn-primary center mt-3 btnEdit"
                    @click="selectPoint(vitrineItem)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="bi bi-pencil-square me-1" viewBox="0 0 16 16">
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                    </svg>
                    Edit vitrine
                  </button>
                  <button type="button" class="col-4 btn btn-primary center mt-3 btnEdit"
                    @click="fetchVitrineItems(vitrineItem)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="bi bi-eye me-1" viewBox="0 0 16 16">
                      <path
                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                    </svg>
                    Show vitrine's items
                  </button>
                  <button type="button" class="col-4 btn btn-danger center mt-3 btnEdit"
                    @click="deleteVitrine(vitrineItem)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                      class="bi bi-trash me-1" viewBox="0 0 16 16">
                      <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                      <path fill-rule="evenodd"
                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L13.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                    Delete vitrine
                  </button>
                </div>

              </div>

              <!-- ******************EDIT VITRINE MODE*************************** -->

              <div v-else>
                <div class="p-3 newQuestion">
                  <form @submit.prevent="saveVitrine(vitrineItem)">
                    <div class="closeDiv" @click="vitrineItem.editMode = false;resetData();">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                      </svg>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <label for="pointNumber" class="col-6">Vitrine number</label>
                        {{ pointNumber }}
                      </div>
                    </div>

                    <div xs12 sm6 offset-sm3>
                      <img :src="imageBase64" alt="" style="width: 100%" />

                      <div block @click="onPickFile2" class="btn mt-3 btnEditChangeImage mb-3">
                        Change image
                      </div>
                      <input type="file" style="display: none" ref="fileInput3" accept="image/*"
                        @change="onFilePicked2" />
                    </div>
                    <div class="form-group">
                      <label for="vitrine">Vitrine</label>
                      <input class="form-control" aria-describedby="vitrine" placeholder="vitrine" name="vitrine" dark
                        label="vitrine" id="vitrine" v-model="vitrine" required />
                    </div>
                    <div class="form-group">
                      <label for="itemName">Vitrine name</label>
                      <input class="form-control" aria-describedby="itemName" placeholder="itemName" name="itemName"
                        dark label="itemName" id="itemName" v-model="itemName" required />
                    </div>
                    <div class="form-group">
                      <label for="pointInformation">Vitrine information</label>
                      <textarea class="form-control" aria-describedby="pointInformation" placeholder="Point information"
                        name="pointInformation" dark label="pointInformation" id="pointInformation"
                        v-model="pointInformation" rows="3"></textarea>
                    </div>
                    <!-- <div class="form-group">
                      <label for="material">material</label>
                      <input class="form-control" aria-describedby="material" placeholder="material" name="material"
                        dark label="material" id="material" v-model="material" />
                    </div>
                    <div class="form-group">
                      <label for="place">place</label>
                      <input class="form-control" aria-describedby="place" placeholder="place" name="place" dark
                        label="place" id="place" v-model="place" />
                    </div>
                    <div class="form-group">
                      <label for="period">period</label>
                      <input class="form-control" aria-describedby="period" placeholder="period" name="period" dark
                        label="period" id="period" v-model="period" />
                    </div> -->
                    <div xs12>
                      <button block type="submit" outline class="btn btn-primary mt-3 btnEdit">
                        <div v-if="loading" class="spinner-border text-primary center" role="status">
                          <span class="sr-only"></span>
                        </div>
                        <!-- <span slot="loader" v-if="loading" class="custom-loader"></span> -->
                        <span v-else>Update</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <!-- <div class="btn fabButton pmd-ripple-effect btn-primary" type="button" @click="newPoint = true">
              <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg" style="font-size: 100px">
                <path fill-rule="evenodd"
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
            </div> -->
          </div>

          <!-- ****************** END OF PRESENTATION FOR VITRINE ONLY*************************** -->


          <!-- ****************** LIST OF ITEMS PER VITRINE *************************** -->

          <div class="newQuestion" v-if="showListOfItem" style="height: 100vh; margin-top: 0px; ">
            <div class="closeDiv" @click="showListOfItem = false">
              <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </div>
            <div v-for="(vitrineItem, index) in vitrineItems" :key="index" :class="{ active: index === activePoint }">
              <div class="row mb-2 border-bottom bg-white pb-2 center" style="max-width: 590px; width: 98vw">

                <div class="row px-3 pt-3 pb-2" style="width: 98vw; display: block; margin: 0 auto;max-width: 590px;"
                  v-if="vitrineItem.editMode != true">
                  <div class="row mb-2">
                    <div class="col-6 mb-2">Point Number:</div>
                    <div class="col-5">
                      {{ vitrineItems[index].point.pointNumber }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <img :src="vitrineItems[index].point.imageBase64" alt="" style="width: 100%" />
                    </div>
                  </div>
                  <div class="row border-bottom my-3">
                    <div class="col-6">vitrine:</div>
                    <div class="col-6 mb-2" style="background: #e6e66254; text-align: center">
                      {{ vitrineItems[index].point.vitrine }}
                    </div>
                  </div>
                  <div class="row border-bottom my-3">
                    <div class="col-6">itemName:</div>
                    <div class="col-6 mb-2" style="background: #e6e66254; text-align: center">
                      {{ vitrineItems[index].point.itemName }}
                    </div>
                  </div>

                  <div class="row border-bottom my-2">
                    <div class="col-12">Point information:</div>
                    <div class="col-11 mb-2" style="background: #e6e66254;
                      text-align: right;
                      display: block;
                      margin: 0 auto;
                    ">
                      {{ vitrineItems[index].point.pointInformation }}
                    </div>
                  </div>
                  <div class="row border-bottom my-3">
                    <div class="col-6">material:</div>
                    <div class="col-6 mb-2" style="background: #e6e66254; text-align: center">
                      {{ vitrineItems[index].point.material }}
                    </div>
                  </div>
                  <div class="row border-bottom my-3">
                    <div class="col-6">place:</div>
                    <div class="col-6 mb-2" style="background: #e6e66254; text-align: center">
                      {{ vitrineItems[index].point.place }}
                    </div>
                  </div>
                  <div class="row border-bottom my-3">
                    <div class="col-6">period:</div>
                    <div class="col-6 mb-2" style="background: #e6e66254; text-align: center">
                      {{ vitrineItems[index].point.period }}
                    </div>
                  </div>

                  <div class="d-flex justify-content-center" style="gap: 10px;">
                    <button type="button" class="btn btn-primary mt-3 btnEdit" @click="selectPoint2(vitrineItem)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                        class="bi bi-pencil-square me-1" viewBox="0 0 16 16">
                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                        <path fill-rule="evenodd"
                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                      </svg>
                      Edit
                    </button>
                    <button type="button" class="btn btn-danger mt-3 btnEdit" @click="deleteItemFromVitrine(index, vitrineItem)">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor"
                        class="bi bi-trash me-1" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                        <path fill-rule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L13.882 4zM2.5 3h11V2h-11z" />
                      </svg>
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ******************EDIT VITRINE'S ITEM MODE*************************** -->


          <div v-if="showEditModeSpecificItem">
            <div class="p-3 newQuestion">
              <form @submit.prevent="saveItem()">
                <div class="closeDiv" @click="resetData();
                ">
                  <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                      d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </div>
                <div class="form-group">
                  <div class="row">
                    <label for="pointNumber" class="col-6">Point number</label>
                    {{ pointNumber }}
                  </div>
                </div>

                <div xs12 sm6 offset-sm3>
                  <img :src="imageBase64" alt="" style="width: 100%" />

                  <div block @click="onPickFile3" class="btn mt-3 btnEditChangeImage mb-3">
                    Change image
                  </div>
                  <input type="file" style="display: none" ref="fileInput3" accept="image/*" @change="onFilePicked2" />
                </div>
                <div class="form-group">
                  <label for="vitrine">vitrine</label>
                  <input class="form-control" aria-describedby="vitrine" placeholder="vitrine" name="vitrine" dark
                    label="vitrine" id="vitrine" v-model="vitrine" required />
                </div>
                <div class="form-group">
                  <label for="itemName">itemName</label>
                  <input class="form-control" aria-describedby="itemName" placeholder="itemName" name="itemName" dark
                    label="itemName" id="itemName" v-model="itemName" required />
                </div>
                <div class="form-group">
                  <label for="pointInformation">Point information</label>
                  <textarea class="form-control" aria-describedby="pointInformation" placeholder="Point information"
                    name="pointInformation" dark label="pointInformation" id="pointInformation"
                    v-model="pointInformation" rows="3"></textarea>
                </div>
                <div class="form-group">
                  <label for="material">material</label>
                  <input class="form-control" aria-describedby="material" placeholder="material" name="material" dark
                    label="material" id="material" v-model="material" />
                </div>
                <div class="form-group">
                  <label for="place">place</label>
                  <input class="form-control" aria-describedby="place" placeholder="place" name="place" dark
                    label="place" id="place" v-model="place" />
                </div>
                <div class="form-group">
                  <label for="period">period</label>
                  <input class="form-control" aria-describedby="period" placeholder="period" name="period" dark
                    label="period" id="period" v-model="period" />
                </div>
                <div xs12>
                  <button block type="submit" outline class="btn btn-primary mt-3 btnEdit">
                    <div v-if="loading" class="spinner-border text-primary center" role="status">
                      <span class="sr-only"></span>
                    </div>
                    <span v-else>Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>



          <!-- ******************END OF LIST OF ITEMS PER VITRINE *************************** -->



          <!-- <div v-else v-for="(pointItem, index) in allPoints" :key="index" :class="{ active: index === activePoint }">
            <div class="row mb-2 border-bottom bg-white pb-2 center" style="max-width: 590px; width: 98vw"> -->
          <!-- ******************NORMAL POINT PRESENTATION*************************** -->

        </div>
      </div>


      <!-- ******************************STATIC DATA*************************** -->

      <!-- <div class="tab-pane fade" id="nav-staticData" role="tabpanel" aria-labelledby="nav-staticData-tab">
        <form @submit.prevent="storeEndPoint" width="90%" class="mb-3 tabpanel p-3">
          <div class="text-center border-bottom pb-2 mb-2">End point</div>
          <div class="border-bottom pb-2 mb-2" style="font-size: 12px">
            The End point is the last point of the game.
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="endPoint">End point</label>
              <input class="form-control" aria-describedby="endPoint" placeholder="endPoint" name="endPoint" dark
                label="endPoint" id="endPoint" v-model="endPoint" rows="3" />
            </div>
            <div class="col-6">
              <button type="submit" class="col-1 ps-0 me-4 mt-4 float-end" style="
                  font-size: 31px;
                  color: #007bff;
                  padding: 0px;
                  margin-top: -7px;
                  border: none;
                  left: 9px;
                ">
                <svg class="bi bi-arrow-right-circle-fill" width="1em" height="1em" viewBox="0 0 16 16"
                  fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8.354 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L9.793 7.5H5a.5.5 0 0 0 0 1h4.793l-2.147 2.146z" />
                </svg>
              </button>
            </div>
          </div>
        </form>

        <div class="form-group mb-3 tabpanel p-3">
          <div class="text-center border-bottom pb-2 mb-2">Points order</div>
          <div class="border-bottom pb-2 mb-2" style="font-size: 12px">
            The Points order is the order in which the user will go from point
            to the other.
          </div>
          <div class="row mb-3">
            <div class="col-7">Add a point to the list:</div>
            <input ref="inputInFocus" class="form-control col-2 ms-3 py-0" aria-describedby="newPointToArray"
              placeholder name="newPointToArray" dark label="newPointToArray" id="newPointToArray"
              v-model="newPointToArray" style="height: 30px" />
   
            <div class="col-1 ps-0 ms-1" style="
                font-size: 22px;
                color: #007bff;
                padding: 0px;
                margin-top: -4px;
              ">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor"
                class="bi bi-plus-circle-fill" viewBox="0 0 16 16" @click="addPointToArray">
                <path
                  d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
              </svg>
            </div>
          </div>
          <div class="row">
            <div class="col-7">
              <div>Point order list:</div>
              <div>
                {{ pointsOrder }}
              </div>
            </div>
            <div class="col-3 mt-2">
              <button class="btn btn-danger" @click="pointsOrder = []">
                Erase
              </button>
            </div>
            <div class="col-2 mt-2">
              <button type="submit" class="col-1 ps-0 me-4 float-end" style="
                  font-size: 31px;
                  color: #007bff;
                  padding: 0px;
                  margin-top: -7px;
                  border: none;
                ">
                <svg class="bi bi-arrow-right-circle-fill" width="1em" height="1em" viewBox="0 0 16 16"
                  fill="currentColor" xmlns="http://www.w3.org/2000/svg" @click="storeVitrineOrder">
                  <path fill-rule="evenodd"
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8.354 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L9.793 7.5H5a.5.5 0 0 0 0 1h4.793l-2.147 2.146z" />
                </svg>
              </button>
            </div>
          </div>
          <div class="row mt-3">
 
          </div>
        </div>

      </div> -->
    </div>
  </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      loginEmail: '',
      loginPassword: '',
      loginError: '',
      actionError: '',
      actionSuccess: '',
      showNewItemsOption: false,
      showEditModeSpecificItem: false,
      showListOfItem: false,
      imageBase64: "",
      allMarkers: "",
      lang: "he",
      editing: false,
      endPoint: "",
      activePoint: null,
      activeQuestion: null,
      zoom: "",
      appExplaination: "",
      anniversary: false,
      randomQuestions: false,
      infoPage: false,
      navigationName: "visitMuseumEinDor",
      showCreateNewNavigationGame: false,
      updateExistingOne: false,
      pointInformation: "",
      showNavigationKindChoices: true,
      navigationNumber: "",
      id: "",
      index: "",
      btnId: "btnId",
      key: "",
      e1: "recent",
      email: "",
      firstName: "",
      lastName: "",
      pointNumber: "",
      vitrineNumber: "",
      pointLinked: "",
      correctAnswer: "",
      wrongAnswer1: "",
      wrongAnswer2: "",
      wrongAnswer3: "",
      showUploadImage: true,
      imageUrl: "",
      showCanvas: false,
      image: null,
      // sentence: "",
      pointsOrder: [],
      newPointToArray: "",
      itemName: "",
      // vitrineName: "",
      vitrine: "",
      navigationKind: "",
      allQuestions: [],
      allPoints: [],
      allVitrines: [],
      question: "",
      newQuestion: false,
      showNewVitrineWindow: false,
      showNewItemWindow: false,
      showVitrineOrder: false,
      material: "",
      place: "",
      itemKey: "",
      period: "",
      vitrinesMain: []
    };
  },
  mounted() {
    firebase.auth().onAuthStateChanged(user => {
      this.$store.commit('setUser', user || null)
      if (user) {
        this.switchLangToHebrew()
      }
    })
  },
  watch: {
    '$store.getters.vitrineOnlyArrayForAdmin'(newVal) {
      if (newVal) this.getVitrineArrayOnly()
    }
  },
  computed: {
    vitrineItems() {
      if (this.$store.getters.vitrineItems) {
        return this.$store.getters.vitrineItems;

      } else {
        console.log("[vitrineItems] NOTING THERE")
        return null
      }

    },
    points() {
      console.log("this.$store.getters.points", this.$store.getters.points);
      return this.$store.getters.points;
    },
    allNavGameNames() {
      var allNavGameNames = this.$store.getters.allNavGameNames;
      return allNavGameNames;
    },
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
    gameParameters() {
      return this.$store.getters.gameParameters;
    },
    // vitrinesMain() {
    //   // return this.$store.getters.vitrinesMain;
    //   return this.$store.getters.vitrineArrayOnly;
    // },
  },
  methods: {
    async login() {
      this.loginError = ''
      try {
        const cred = await firebase.auth().signInWithEmailAndPassword(this.loginEmail, this.loginPassword)
        this.$store.commit('setUser', cred.user)
      } catch (err) {
        this.loginError = err.message
      }
    },
    async loginWithGoogle() {
      this.loginError = ''
      try {
        const provider = new firebase.auth.GoogleAuthProvider()
        const cred = await firebase.auth().signInWithPopup(provider)
        this.$store.commit('setUser', cred.user)
      } catch (err) {
        this.loginError = err.message
      }
    },
    async logout() {
      await firebase.auth().signOut()
      this.$store.commit('setUser', null)
    },
    switchLangToHebrew() {
      this.$store.dispatch("setHebrewLang");
      this.$store.dispatch("fetchVitrinesOnlyForAdmin", { lang: this.lang, navigationName: this.navigationName })
        .then(() => this.getVitrineArrayOnly());
    },
    switchLangToArabic() {
      this.$store.dispatch("setArabicLang");
      this.$store.dispatch("fetchVitrinesOnlyForAdmin", { lang: this.lang, navigationName: this.navigationName })
        .then(() => this.getVitrineArrayOnly());
    },
    switchLangToEnglish() {
      this.$store.dispatch("setEnglishLang");
      this.$store.dispatch("fetchVitrinesOnlyForAdmin", { lang: this.lang, navigationName: this.navigationName })
        .then(() => this.getVitrineArrayOnly());
    },

    saveItem() {
      this.showEditModeSpecificItem = false
      console.log("UPDATE new Item");
      // element.editMode = false;
      const itemInVitrine = {
        pointNumber: this.pointNumber,
        image: this.image,
        itemName: this.itemName,
        vitrine: this.vitrine,
        material: this.material,
        place: this.place,
        period: this.period,
        navigationName: this.navigationName,
        pointInformation: this.pointInformation,
        imageBase64: this.imageBase64,
        itemKey: this.itemKey
      };

      console.log("create point", itemInVitrine);

      this.actionError = ''
      this.actionSuccess = ''
      const vitrineNumber = itemInVitrine.vitrine
      this.$store.dispatch("updateItem", itemInVitrine)
        .then(() => {
          this.actionSuccess = 'Item updated.'
          this.$store.dispatch("fetchVitrineItems", vitrineNumber)
        })
        .catch(err => { this.actionError = err.message })

      this.pointNumber = "";
      this.image = "";
      this.itemName = "";
      this.vitrine = "";
      this.pointInformation = "";
      this.imageBase64 = "";
      this.itemKey = ""
      this.material = "";
      this.place = "";
      this.period = "";
      // var getPointsInterval = setInterval(() => {
      //   this.getAllPoints();
      //   console.log("getPointsInterval");
      //   if (this.loading === false) {
      //     clearInterval(getPointsInterval);
      //   }
      // }, 1000);
    },



    getLastPoint() {
      this.endPoint = this.gameParameters.lastPoint;
      console.log("[getLastPoint] this.endPoint ", this.endPoint);
    },
    // getPointsOrders() {
    //   this.pointsOrder = this.gameParameters.pointsOrder;
    // },
    // getAllPoints() {
    //   console.log("[getAllPoints]")
    //   var newArrayOfPoints = [];
    //   var arrayOfPoints = Object.values(this.$store.getters.points);
    //   arrayOfPoints.forEach(function (results) {
    //     if (results != null) {
    //       newArrayOfPoints.push({ results, editMode: false });
    //     }
    //   });
    //   this.allPoints = newArrayOfPoints;
    //   console.log("[getAllPoints] this.allPoints", this.allPoints)
    //   this.$forceUpdate();
    // },
    getVitrineArrayOnly() {
      // console.log("[getVitrineArrayOnly]")
      var newArrayOfVitrines = [];
      var arrayOfVitrines = Object.values(this.$store.getters.vitrineOnlyArrayForAdmin);
      // console.log("[getVitrineArrayOnly] arrayOfVitrines", arrayOfVitrines)

      arrayOfVitrines.forEach(function (results) {
        if (results != null) {
          newArrayOfVitrines.push({ results: results, editMode: false });
        }
      });
      this.vitrinesMain = newArrayOfVitrines;
      console.log("[getVitrineArrayOnly] this.getVitrineArrayOnly", this.vitrinesMain)
      this.$forceUpdate();
    },


    selectQuestion(element) {
      element.editMode = true;
      this.pointLinked = element.results.data.pointLinked;
      this.question = element.results.data.question;
      this.correctAnswer = element.results.data.correctAnswer;
      this.wrongAnswer1 = element.results.data.wrongAnswer1;
      this.wrongAnswer2 = element.results.data.wrongAnswer2;
      this.wrongAnswer3 = element.results.data.wrongAnswer3;
    },
    selectPoint(element) {
      element.editMode = true;
      console.log("element", element);
      this.itemName = element.results.itemName;
      this.vitrine = element.results.vitrine;
      this.material = element.results.material;
      this.place = element.results.place;
      this.period = element.results.period;
      this.pointNumber = element.results.pointNumber;
      this.pointInformation = element.results.pointInformation;
      this.imageBase64 = element.results.imageBase64;
      this.scrollToTop();
    },

    //*****************J'AI DU AJOUTER MANUELLEMENT LES ITEMKEY DANS FIREBASE CAR ILS N'EXISTE PAS DANS "ELEMENT". IL FAUT FAIRE EN SORTE QU'ILS SOIENT DANS "ELEMENT"  */
    selectPoint2(element) {
      element.editMode = true;
      console.log("element", element);
      this.itemName = element.point.itemName;
      this.vitrine = element.point.vitrine;
      this.material = element.point.material;
      this.place = element.point.place;
      this.period = element.point.period;
      this.pointNumber = element.point.pointNumber;
      this.pointInformation = element.point.pointInformation;
      this.imageBase64 = element.point.imageBase64;
      this.itemKey = element.point.itemKey
      this.showEditModeSpecificItem = true
      this.scrollToTop();
    },
    fetchVitrineItems(element) {
      element.editMode = false;
      console.log("element", element);
      let vitrineNumber = element.results.pointNumber;
      console.log("this.pointNumber", vitrineNumber);
      this.$store.dispatch("fetchVitrineItems", vitrineNumber);
      this.showListOfItem = true
      this.scrollToTop();
    },
    resetData() {
      this.pointNumber = "";
      this.image = "";
      this.itemName = "";
      this.vitrine = "";
      this.pointInformation = "";
      this.imageBase64 = "";
      this.itemKey = ""
      this.material = "";
      this.place = "";
      this.period = "";
      this.showEditModeSpecificItem = false
    },

    addPointToArray() {
      if (this.newPointToArray === "") {
        alert(
          "Please fill the new point number to be added to the new array of points"
        );
      } else {
        this.pointsOrder.push(Number(this.newPointToArray));
        this.newPointToArray = "";
        this.$refs.inputInFocus.focus();
        // console.log("addPointToArray => pointsOrder", this.pointsOrder);
      }
    },
    openVitrineOrder() {
      this.showNewItemsOption = false;
      this.actionError = '';
      this.$store.dispatch("fetchVitrineOrder").then(() => {
        this.pointsOrder = [...(this.$store.getters.vitrineOrder || [])];
        this.showVitrineOrder = true;
        this.scrollToTop();
      }).catch(err => { this.actionError = err.message });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    moveOrderItem(idx, direction) {
      const target = idx + direction;
      if (target < 0 || target >= this.pointsOrder.length) return;
      const arr = this.pointsOrder;
      [arr[idx], arr[target]] = [arr[target], arr[idx]];
    },
    eraseVitrineOrder() {
      if (window.confirm("Effacer toute la liste ? (elle ne sera écrasée dans la base qu'après validation)")) {
        this.pointsOrder = [];
      }
    },
    storeVitrineOrder() {
      if (!window.confirm("Remplacer l'ordre des vitrines actuellement en ligne par cette liste ?")) return;
      this.actionError = '';
      this.actionSuccess = '';
      this.$store.dispatch("storeVitrineOrder", {
        pointsOrder: this.pointsOrder,
        navigationName: this.navigationName,
      }).then(() => {
        this.actionSuccess = "Vitrine order updated.";
        this.showVitrineOrder = false;
        this.pointsOrder = [];
        this.newPointToArray = "";
      }).catch(err => { this.actionError = err.message });
    },
    deleteVitrine(element) {
      const pointNumber = element.results.pointNumber;
      if (!window.confirm(`Supprimer la vitrine n°${pointNumber} et tous ses objets ? Cette action est irréversible.`)) return;
      this.actionError = '';
      this.actionSuccess = '';
      this.$store.dispatch("deleteVitrine", { pointNumber, navigationName: this.navigationName })
        .then(() => {
          this.actionSuccess = "Vitrine deleted.";
          this.$store.dispatch("fetchVitrinesOnlyForAdmin", { lang: this.lang, navigationName: this.navigationName })
            .then(() => this.getVitrineArrayOnly());
        })
        .catch(err => { this.actionError = err.message });
    },
    deleteItemFromVitrine(itemKey, element) {
      const vitrineNumber = element.point.vitrine;
      if (!window.confirm(`Supprimer l'objet "${element.point.itemName}" ? Cette action est irréversible.`)) return;
      this.actionError = '';
      this.actionSuccess = '';
      this.$store.dispatch("deleteItem", { vitrine: vitrineNumber, itemKey })
        .then(() => {
          this.actionSuccess = "Item deleted.";
          this.$store.dispatch("fetchVitrineItems", vitrineNumber);
        })
        .catch(err => { this.actionError = err.message });
    },
    // startEditingNavGame(navGame) {
    //   console.log("[startEditingNavGame] navGame", navGame);
    //   this.navigationName = navGame;
    //   this.updateExistingOne = false;
    //   this.showCreateNewNavigationGame = false;
    //   this.showNavigationKindChoices = false;
    //   this.$store.dispatch("fetchNavtigationData", navGame);
    //   this.$store.dispatch("fetchPoints", this.lang, navGame);
    //   this.$store.dispatch("fetchPoints", { lang: this.lang, navGame: navGame });
    //   this.getAllPoints();
    // },

    createNewItem() {
      console.log("Create new poiint");
      const item = {
        audioUrl: "",
        imageBase64: this.imageUrl,
        pointNumber: this.pointNumber,
        image: this.image,
        itemName: this.itemName,
        vitrine: this.vitrine,
        material: this.material,
        place: this.place,
        period: this.period,
        navigationName: this.navigationName,
        pointInformation: this.pointInformation,
      };
      console.log("create item", item);
      this.actionError = '';
      this.actionSuccess = '';
      this.$store.dispatch("createNewItem", item)
        .then(() => { this.actionSuccess = "Item created."; })
        .catch(err => { this.actionError = err.message });
      this.pointNumber = "";
      this.itemName = "";
      this.vitrine = "";
      this.material = "";
      this.place = "";
      this.period = "";
      this.pointInformation = "";
      this.imageUrl = "";
      this.image = null;
    },
    createNewVitrine() {
      console.log("Create new poiint");
      const vitrine = {
        audioUrl: "",
        imageBase64: this.imageUrl,
        pointNumber: this.pointNumber,
        image: this.image,
        itemName: this.itemName,
        vitrine: this.vitrine,
        navigationName: this.navigationName,
        pointInformation: this.pointInformation,
      };
      console.log("create vitrine", vitrine);
      this.actionError = '';
      this.actionSuccess = '';
      this.$store.dispatch("createNewVitrine", vitrine)
        .then(() => { this.actionSuccess = "Vitrine created."; })
        .catch(err => { this.actionError = err.message });
      // this.$store.dispatch("createNewVitrine", {lang: this.lang, vitrine: vitrine});

      this.pointNumber = "";
      this.itemName = "";
      this.vitrine = "";
      this.pointInformation = "";
      this.imageUrl = "";
      this.image = null;
    },
    saveVitrine(element) {
      element.editMode = false;
      console.log("UPDATE new vitrine");
      const vitrine = {
        pointNumber: this.pointNumber,
        image: this.image,
        itemName: this.itemName,
        vitrine: this.vitrine,
        navigationName: this.navigationName,
        pointInformation: this.pointInformation,
        imageBase64: this.imageBase64,
      };
      console.log("update vitrine", vitrine);
      this.actionError = '';
      this.actionSuccess = '';
      this.$store.dispatch("updateVitrine", vitrine)
        .then(() => {
          this.actionSuccess = "Vitrine updated.";
          this.$store.dispatch("fetchVitrinesOnlyForAdmin", { lang: this.lang, navigationName: this.navigationName })
            .then(() => this.getVitrineArrayOnly());
        })
        .catch(err => { this.actionError = err.message });
      this.pointNumber = "";
      this.image = "";
      this.itemName = "";
      this.vitrine = "";
      this.pointInformation = "";
      this.imageBase64 = "";
    },
 
    // ******************************************** UPLOAD PICTURE**********************************
    onPickFile() {
      // the $refs below give us access to all the ref elements in the template of this component
      console.log("this.$refs.fileInput", this.$refs.fileInput);
      this.$refs.fileInput.click();
    },
    onPickFile2() {
      // the $refs below give us access to all the ref elements in the template of this component
      console.log("this.$refs.fileInput3[0]", this.$refs.fileInput3[0]);


      this.$refs.fileInput3[0].click();

      // this.$refs.fileInput2.click();
    },
    onPickFile3() {
      // the $refs below give us access to all the ref elements in the template of this component
      console.log("this.$refs.fileInput3", this.$refs.fileInput3);

      // this.$refs.fileInput3[0].click();
      this.$refs.fileInput3.click();

    },
    onFilePicked2(event) {
      console.log("[onFilePIcked] event", event);
      const files = event.target.files;
      console.log("[onFilePIcked] files", files);

      // As we can choose only one file, we take the first one in the array
      this.filename = files[0].name;
      // console.log("[onFilePIcked] filename", this.filename);

      // Simple chack if the file is valid
      if (this.filename.lastIndexOf(".") <= 0) {
        return alert("Please enter a valid image");
      }
      // Turn it into base64
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        // the result here is a base64 image
        this.imageUrl = fileReader.result;
        // console.log("this.imageUrl", this.imageUrl);
        this.imageBase64 = fileReader.result;
        var img = new Image();
        img.src = this.imageUrl;
      });
      fileReader.readAsDataURL(files[0]);
      this.showCanvas = true;
     // this.showUploadImage = false;
    },
    onFilePicked(event) {
      // We get the wanted file
      console.log("[onFilePIcked] event", event);
      const files = event.target.files;
      console.log("[onFilePIcked] files", files);

      // As we can choose only one file, we take the first one in the array
      this.filename = files[0].name;
      console.log("[onFilePIcked] filename", this.filename);

      // Simple chack if the file is valid
      if (this.filename.lastIndexOf(".") <= 0) {
        return alert("Please enter a valid image");
      }
      // Turn it into base64
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        // the result here is a base64 image
        this.imageUrl = fileReader.result;
        // console.log("this.imageUrl", this.imageUrl);

        var img = new Image();
        img.src = this.imageUrl;

        img.addEventListener("load", () => {
          let context = this.$refs.canvas.getContext("2d");
          let image = this.$refs.imageToCanvas;
          // let imageWidth = window.outerWidth - 16
          let imageWidth = 500;
          this.$refs.canvas.width = imageWidth;
          this.$refs.canvas.height = (imageWidth * image.height) / image.width;
          // Now I create the image - what?, top, left, width, height
          context.drawImage(
            image,
            0,
            0,
            imageWidth,
            (imageWidth * image.height) / image.width
          );
          this.image = this.dataURItoBlob(this.$refs.canvas.toDataURL());
        });
      });
      fileReader.readAsDataURL(files[0]);
      this.showCanvas = true;
    //  this.showUploadImage = false;
    },

    dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(",")[1]);
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: mimeString });
      console.log("[dataURItoBlob] blob", blob);
      return blob;
    },
  },
};
</script>

<style scoped>
.adminWrapper {
  display: block;
  width: 100%;
  direction: ltr;
  text-align: left;
}

.loginWrapper {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.loginCard {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  width: 320px;
}

.newItemsButtons {
  height: 45px;
  padding-top: 8px !important;
  width: 45px;
  /* position: relative !important; */
  bottom: 76px !important;
  background-color: gray !important;
  right: max(16px, calc((100vw - 590px) / 2 + 16px)) !important;
}

.btnEditChangeImage {
  height: 35px;
  border: 0px;
  border-radius: 16px;
  margin: 0 auto;
  display: block;
  max-width: 170px;
  color: #3c69d9;
  border: solid #3c69d9 2px;
  padding-top: 4px;
}

.btnEdit {
  padding: 0px 20px;
  /* height: 35px; */
  border: 0px;
  border-radius: 16px;
  margin: 0 auto;
  display: block;
  max-width: 150px;
  /* min-width: 120px; */
}

.showButtons {
  padding: 0px 20px;
  height: 35px;
  border: 0px;
  border-radius: 16px;
  /* min-width: 174px; */
  margin: 0 auto;
  display: block;
}

#dropdownMenuButton {
  padding: 0px 20px;
  height: 35px;
  border: 0px;
  border-radius: 16px;
  /* min-width: 174px; */
  margin: 0 auto;
  display: block;
}

.tabpanel {
  background: rgba(255, 255, 255, 0.6);
}

.databaseAffected {
  position: fixed;
  padding-top: 20px;
  width: 100%;
  background: white;
  z-index: 5;
  padding-bottom: 15px;
  top: 0px;
  max-width: 590px;
}

nav {
  position: fixed;
  top: 54px;
  width: 100%;
  background: white;
  z-index: 5;
}

.closeDiv {
  position: absolute;
  top: 0px;
  right: 0px;
  border-radius: 50px;
  height: 40px;
  width: 40px;
  font-size: 25px;
  color: black;
  cursor: pointer;
}

.newQuestion {
  position: fixed;
  top: 0px;
  background: white;
  height: 94vh;
  width: 94vw;
  z-index: 2;
  margin-top: 3vh;
  border: solid 1px #e0e0e0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden scroll;
  border-radius: 10px;
  z-index: 6;
  padding: 8px;
  max-width: 590px;
}

.langTab {
  padding: 6px 0;
  cursor: pointer;
  color: #6c757d;
  border-bottom: 3px solid transparent;
  font-weight: 500;
  transition: color 0.15s, border-color 0.15s;
}

.langTab.active {
  color: #63C4C3;
  border-bottom-color: #63C4C3;
  font-weight: 700;
}

.vitrineCard {
  border: solid 1px #e0e0e0;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.15s;
}

.vitrineCard:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
}

.fabButton {
  position: fixed;
  bottom: 10px;
  right: max(10px, calc((100vw - 590px) / 2 + 10px));
  border-radius: 50px;
  background: #63C4C3;
  padding: 0px;
  z-index: 20;
}

.btn-primary {
  background-color: #63C4C3 !important;
  border-color: #63C4C3 !important;
}

.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active {
  background-color: #4fb0af !important;
  border-color: #4fb0af !important;
}

.center {
  display: block;
  margin: 0px auto;
}

.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}

.colorBtn {
  border-radius: 36px;
  height: 56px;
  color: white;
}

.myModal {
  min-height: 340px;
  width: 300px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: white;
  /* border: 5px solid; */
  -moz-box-shadow: 0 0 15px 15px;
  -webkit-box-shadow: 0 0 15px 15px;
  box-shadow: 0 0 15px 15px var(--box-shadow-color);
}

.over {
  position: absolute;
  top: 0px;
  font-size: 18px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 5;
}

.fitScreen {
  max-width: 100%;
}

.uploadPicture {
  border-style: dashed;
  border-color: grey;
  border-width: thin;
  height: 144px;
  margin: 0 auto;
}


@media only screen and (max-width: 600px) {
  .newQuestion {
    margin-left: 3vw;
  }
}
</style>


